import { render, staticRenderFns } from "./perkawinan.vue?vue&type=template&id=1e3753fc&scoped=true&"
import script from "./perkawinan.vue?vue&type=script&lang=js&"
export * from "./perkawinan.vue?vue&type=script&lang=js&"
import style0 from "./perkawinan.vue?vue&type=style&index=0&id=1e3753fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3753fc",
  null
  
)

export default component.exports